
import genericService from '../genericService';

const urls = {
    EXCISE_CALCULATOR: 'excise-calculator/excise-calculator'
}

export default {
    async exciseCalculator(body, callback){
        await genericService.post(urls.EXCISE_CALCULATOR, body).then(callback);
    }
}